var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHorizontalOval2Inline = function SvgHorizontalOval2Inline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1639,
    height: 622,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#horizontal-oval2_inline_svg__a)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#horizontal-oval2_inline_svg__b)",
    d: "M1434.54 378.171C1290.57 435.475 1113.45 522 752.878 522 392.303 522 100 438.066 100 334.529 100 230.991 874.713 100 1235.29 100c360.57 0 363.02 212.987 199.25 278.171Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "horizontal-oval2_inline_svg__b",
    x1: 437.76,
    x2: 2733.91,
    y1: 323.897,
    y2: 414.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#255DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#00A98F"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "horizontal-oval2_inline_svg__a",
    width: 1639,
    height: 622,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_699_1818",
    stdDeviation: 50
  })))));
};
export default SvgHorizontalOval2Inline;